import { render, staticRenderFns } from "./chooseConfig.vue?vue&type=template&id=2a786022&scoped=true"
import script from "./chooseConfig.vue?vue&type=script&lang=ts"
export * from "./chooseConfig.vue?vue&type=script&lang=ts"
import style0 from "./chooseConfig.vue?vue&type=style&index=0&id=2a786022&prod&lang=scss&scoped=true"
import style1 from "./chooseConfig.vue?vue&type=style&index=1&id=2a786022&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a786022",
  null
  
)

export default component.exports